import { handleActions } from 'redux-actions';

import { actions } from './actions';

const initialState = {
  modals: [],
};

const openModalReducer = (state = initialState, { payload }) => {
  payload.open = true;
  return {
    ...state,
    modals: state.modals.concat(payload),
  };
};

const closeModalReducer = (state = initialState) => {
  const newState = state.modals.slice();
  newState.pop();
  return {
    ...state,
    modals: newState,
  };
};

const reducer = handleActions(
  {
    [actions.openModal]: openModalReducer,
    [actions.closeModal]: closeModalReducer,
  },
  initialState,
);

export default reducer;
